// @flow

export function isPhone(value?: ?string) {
  return typeof value === "string" && /^[0-9 -. ]+$/i.test(value) ? true : false;
}
